var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIntersection = function SvgIntersection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.83334V2.5L12.5 2.5V5.83334C12.5 6.29167 12.6632 6.68403 12.9896 7.01042C13.316 7.33681 13.7083 7.5 14.1667 7.5L17.5 7.5V5.83334L14.1667 5.83334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 13.125V16.6667H10.8333V13.125H9.16667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 7.8125V11.3542H10.8333V7.8125H9.16667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 2.5V6.04167H10.8333V2.5H9.16667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 10.4167H17.0833V8.75H13.5417V10.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22917 10.4167H11.7708V8.75L8.22917 8.75V10.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 10.4167H6.45833V8.75H2.91667L2.91667 10.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.83333L5.83333 2.5L7.5 2.5L7.5 5.83333C7.5 6.29167 7.33681 6.68403 7.01042 7.01042C6.68403 7.33681 6.29167 7.5 5.83333 7.5L2.5 7.5L2.5 5.83333L5.83333 5.83333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.3333H17.5V11.6667H14.1667C13.7083 11.6667 13.316 11.8299 12.9896 12.1562C12.6632 12.4826 12.5 12.875 12.5 13.3333L12.5 16.6667H14.1667L14.1667 13.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 13.3333H2.5L2.5 11.6667H5.83333C6.29167 11.6667 6.68403 11.8299 7.01042 12.1562C7.33681 12.4826 7.5 12.875 7.5 13.3333L7.5 16.6667H5.83333L5.83333 13.3333Z",
    fill: "white"
  }))));
};
export { SvgIntersection as ReactComponent };
export default __webpack_public_path__ + "assets/2499af89.svg";